import { render, staticRenderFns } from "./CreateBlue.vue?vue&type=template&id=322e80f9&scoped=true&"
var script = {}
import style0 from "./CreateBlue.vue?vue&type=style&index=0&id=322e80f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e80f9",
  null
  
)

export default component.exports